/*
 * @Author: zhengxiaowen 
 * @Date: 2018-08-24 23:55:07 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2019-04-25 10:29:48
 */
import platform from '@/config/platform'

let host = platform.host

let api = {
    baseLookupTypeService_find: `${host}/baseServer/baseLookupTypeService/find`,
    saleBrcCodedataService_findMtlSystemItemsPagination: `${host}/pdaServer/saleBrcCodedataService/findMtlSystemItemsPagination?v=/v1/`,
}

export default api;


// WEBPACK FOOTER //
// ./src/page/demo/config/api.js